<app-page-header title="Store Positions" description="Define the in-store positions available when slotting products."></app-page-header>
<!-- stepPosition="center" — see the note in slotting-board-v2.component.html. "right" on a
     full-width grid falls back right -> bottom -> left -> top and ends up clipped off the page. -->
<div class="grid"
  joyrideStep="settings-add" stepPosition="center"
  [title]="'Set up Store Positions'"
  [text]="'Click the + button above the grid to add a store position, fill in the row, then click the checkmark to save.'">
<dx-data-grid #storePositionGrid
  [dataSource]="dataSource"
  [remoteOperations]="false"
  [rowAlternationEnabled]="true"
  [height]="'100%'"
  [loadPanel]="{ enabled: false }"
>
  <dxo-editing
    mode="batch"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>
  <dxi-column dataField="id" dataType="integer" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="position_name" dataType="string" caption="Position Name">
    <dxi-validation-rule type="required" message="store-position name is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="position_description" dataType="string" caption="Description"></dxi-column>
  <dxi-column dataField="group_id" dataType="number" [visible]="false"></dxi-column>
  <dxi-column dataField="location_id" dataType="number" [visible]="false"></dxi-column>
</dx-data-grid>
</div>

<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
  >
  </dx-load-panel>
